import { Box, Paper, Typography } from '@mui/material'
import { ReactNode } from 'react'

type PaperWithContentProps = {
  title: string
  subtitle?: ReactNode
  button: ReactNode
}

export const PaperWithContent = ({
  title,
  subtitle,
  button,
}: PaperWithContentProps) => {
  return (
    <Paper
      sx={{
        height: 260,
        p: 4,
        boxShadow: '0px 4px 12px rgba(63, 69, 91, 0.11)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
      }}
    >
      <Typography variant="h3" textAlign="center">
        {title}
      </Typography>

      {subtitle && (
        <Typography
          variant="caption1"
          color="text.secondary"
          textAlign="center"
          mt={2}
        >
          {subtitle}
        </Typography>
      )}

      <Box mt={3}>{button}</Box>
    </Paper>
  )
}
